import api from '@/api';
import store from '@/store';

const { dispatch, state: { tag, merchant, type, otherPay, paymentMethod }, getters } = store;

async function getTagList() {
  const { data } = await api.productTag.list();
  const tagList = data || [];
  dispatch('tag/setTagList', tagList);
}

async function getTypeList() {
  const { data } = await api.productCategory.list();
  const typeList = data || [];
  dispatch('type/setTypeList', typeList);
}

async function getMerchantList() {
  const { data } = await api.merchant.list();
  const merchantList = data || [];
  dispatch('merchant/setMerchantList', merchantList);
}

async function getMerchantCategories() {
  const { data: { data } } = await api.merchantcategory.list({ pageSize: 0, pageNo: 1 });
  dispatch('merchant/setMerchantCategories', data || []);
}

async function getOtherPayList() {
  const { data } = await api.otherPoint.list({ balance: true, deduct: true });
  dispatch('otherPay/setOtherPayList', data || []);
}

async function getPaymetMethods() {
  const { data } = await api.paymentMethod.getList();
  dispatch('paymentMethod/setPaymentMethod', data || []);
}

const itemMixin = {
  created() {
    if (tag.tagList.length === 0) {
      getTagList();
    }
    if (type.typeList.length === 0) {
      getTypeList();
    }
    if (merchant.merchantList.length === 0) {
      getMerchantList();
    }
    if (merchant.categories.length === 0) {
      getMerchantCategories();
    }
    if (otherPay.otherPayList.length === 0) {
      getOtherPayList();
    }
    if (paymentMethod.paymentMethods.length === 0) {
      getPaymetMethods();
    }
  },
  computed: {
    tagSelect() {
      return tag.tagSelect;
    },
    tagList() {
      return tag.tagList;
    },
    typeSelect() {
      return type.typeSelect;
    },
    typeList() {
      return type.typeList;
    },
    merchantList() {
      return merchant.merchantList;
    },
    merchantSelect() {
      return merchant.merchantSelect;
    },
    merchantCategories() {
      return merchant.categories;
    },
    otherPayList() {
      return otherPay.otherPayList;
    },
    paymentMethod() {
      return paymentMethod.paymentMethod;
    },
  },
};

export default itemMixin;
